import { render, staticRenderFns } from "./TheCoursesMenu.vue?vue&type=template&id=0031ac36&scoped=true&"
import script from "./TheCoursesMenu.vue?vue&type=script&lang=js&"
export * from "./TheCoursesMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheCoursesMenu.vue?vue&type=style&index=0&id=0031ac36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0031ac36",
  null
  
)

export default component.exports